import React, { useEffect, useMemo, useRef } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

function TimeComponent(props: any) {
  const { name, label, isRequired, value, ...rest } = props;
  const { setFieldTouched, isSubmitting, setFieldValue } = useFormikContext();
  const calendarRef = useRef<Calendar>(null);

  const dateConversion = useMemo(() => {
    if (typeof value === "string") {
      const [h, m, s] = value.split(":").map((i: string) => Number.parseInt(i));
      const date = new Date();
      date.keepTime = true;
      date.setHours(h, m, s);
      return date;
    }
    return null;
  }, [value]);

  useEffect(() => {
    if (!isSubmitting) return;
    setFieldTouched(name, true, true);
  }, [isSubmitting]);

  const footerTamplete = () => {
    return (
      <div>
        <Button label="Close" onClick={closeCalendar} className="p-button-text" />
      </div>
    );
  };

  const closeCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.hide();
    }
  };

  return (
    <div className="py-2">
      {label && (
        <label htmlFor={name} className={isRequired ? "isRequired" : ""}>
          {" "}
          {label}
        </label>
      )}
      <Calendar
        value={dateConversion}
        alt={name}
        name={name}
        {...rest}
        timeOnly
        dateFormat="hh:mm"
        hourFormat="12"
        onChange={(e: any) => {
          if (e.value != null) {
            const date = new Date(e.value);
            const h = date.getHours().toString().padStart(2, "0");
            const m = date.getMinutes().toString().padStart(2, "0");
            const time = `${h}:${m}:00`;
            if (time != rest.value) {
              setFieldValue(name, time);
            }
          } else {
            setFieldValue(name, null);
          }
        }}
        footerTemplate={footerTamplete}
        ref={calendarRef}
      />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default TimeComponent;
